document.addEventListener("DOMContentLoaded", function () {
  function blockSoldOutOptions() {
    $(".product-form__controls--dropdown").each(function () {
      const elListItem = $(this).find(".dropdown-select ul li");
      elListItem.off("click.soldout").on("click.soldout", function (e) {
        if ($(this).find(".pills-variant-labels").hasClass("disabled")) {
          e.stopImmediatePropagation();
          return false;
        }
      });
    });
  }

  setTimeout(blockSoldOutOptions, 500);
  document.addEventListener("shopify:section:load", function () {
    setTimeout(blockSoldOutOptions, 500);
  });
});
